// App.js
import React from 'react';
import {Routes, Route } from 'react-router-dom';
import Croqly from './components/croqly';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Contact from './components/Contact';
import AppStoreRedirect from './components/AppStoreRedirect';
function App() {
  return (
    
      <Routes>
        <Route path="/" element={<Croqly />} />
         <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/download" element={<AppStoreRedirect />} />
      </Routes>
  
  );
}

export default App;